import { Component, Input, ViewEncapsulation } from '@angular/core';
import { InputErrors, TextInputComponent } from '../../../forms';

/**
 * The Nomidio Phone Input Component presents an internationalised text input field to the user.
 *
 * Validation is built in, if the value is an invalid phone number the control will have the 'phone' error.
 *
 * The control you provide to this component will have its value set to a {@link PhoneInputValue} instance.
 *
 * * You can get the number with {@link PhoneInputValue.e164Number}.
 * * Set the number by changing the control's value.
 *
 *
 * @example // Setup
 * // ts
 * constructor(
 * ) {
 *   this.form = new FormGroup({
 *     'phone': new FormControl(),
 *   });
 * }
 * // html
 * <nom-phone-input [control]="phone"></nom-phone-input>
 *
 * @example // Get the phone number
 * const phoneNumber = phone.value?.e164Number;
 *
 * @example // Set the phone number
 * phone.setValue('+447498765432');
 */
@Component({
    selector: 'nom-phone-input',
    templateUrl: './phone-input.component.html',
    styleUrls: ['./phone-input.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PhoneInputComponent extends TextInputComponent {
  /**
   * A list of countries to prefer in the dropdown.
   *
   * @see https://github.com/jackocnr/intl-tel-input preferredCountries
   */
   @Input()
   public preferredCountries: string[] = ['gb', 'us'];

   @Input()
   public override errors: InputErrors = {
     'required': 'This field is required',
     'phone': 'This must be a valid phone number',
   };
}
